/**
 * @file JobSearchEmptySlot.tsx
 *
 * @fileoverview Renders icon and text if none job is selected on job search.
 */

import React from 'react';
import RichFormattedMessage from '~/jobiqo/components/RichFormattedMessage';
import { Slottable } from '~/jobiqo/components/Slots/interfaces';

interface JobSearchEmptySlotProps {
  /**
   * The count of jobs.
   */
  totalCount?: Slottable<number>;
}

export const JobSearchEmptySlot = ({}: JobSearchEmptySlotProps) => {
  return (
    <div>
      <RichFormattedMessage
        id="job_detail_panel_instructions"
        defaultMessage="To see all the details of a job posting please choose one from the list on the left."
      />
    </div>
  );
};
export default JobSearchEmptySlot;
